'use strict';

const Marionette = require('backbone.marionette');
const _ = require('underscore');

export default Marionette.View.extend({
  template: require('./templates/multiple-choice.hbs'),
  className: 'custom-form-question',
  ui: {
    select: 'select',
    additionalInput: '.additional-input',
  },
  events: {
    'change @ui.select': 'onChange',
  },

  serializeData() {
    const json = this.model.toJSON();
    json.additionalInputPlaceholder = this.model.get('body');

    return json;
  },

  onChange() {
    const value = this.ui.select.val();
    const selectedOption = _.find(this.model.get('options'), option => option.id === parseInt(value, 10));
    this.model.set('value', value);

    if (selectedOption && selectedOption.has_additional_input) {
      this.ui.additionalInput.show();
    } else {
      const additionalInput = document.getElementById(`custom-question-${this.model.get('id')}-additional-input`);
      additionalInput.value = '';
      this.ui.additionalInput.hide();
    }
  },
});
